import { makeVar, useReactiveVar } from "@apollo/client";
import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Skeleton,
  Typography,
} from "@mui/material";
import { useGetReleaseNotesQuery } from "graphql/generated/schema-types";
import _ from "lodash";
import moment from "moment";
import { FC, useState } from "react";
import styled from "styled-components/macro";
import packageJson from "../../package.json";

const Header = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.2rem;
  font-weight: bold;
`;

const HeaderContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  color: ${({ theme }) => (theme.palette.mode === "dark" ? "white" : "black")};
`;

const ReleaseDescription = styled.div`
  color: ${({ theme }) => (theme.palette.mode === "dark" ? "white" : "black")};
`;

export const ShowReleaseNotes = makeVar(false);

export const ReleaseNotes: FC = () => {
  const [idx, setIdx] = useState<number>(0);
  const showReleaseNotes = useReactiveVar(ShowReleaseNotes);
  const { data, loading } = useGetReleaseNotesQuery({
    skip: !showReleaseNotes,
  });
  const releaseNotes = data?.releaseNotes?.filter(
    (node): node is NonNullable<typeof node> => node != null,
  );

  return (
    <Dialog open={showReleaseNotes} onClose={() => ShowReleaseNotes(false)}>
      {!loading ? (
        <DialogContent>
          <DialogTitle>
            <HeaderContainer>
              <Header>{releaseNotes?.[idx]?.tagName}</Header>
              <div>
                <FormControl>
                  <InputLabel>Release Date</InputLabel>
                  <Select
                    label={"Release Date"}
                    labelId="release-date-label"
                    id="release-date-select"
                    value={idx ?? null}
                    onChange={(e) => {
                      const _idx = parseInt(e.target.value.toString());
                      if (!_.isNaN(_idx)) setIdx(_idx);
                    }}
                    inputProps={{
                      name: "releaseDate",
                      id: "releaseDate",
                    }}
                  >
                    {releaseNotes?.map((node, idx) => (
                      <MenuItem key={node.tagName} value={idx}>
                        {moment(node.createdAt).format("L")}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
            </HeaderContainer>
          </DialogTitle>
          <Typography component="div">
            <ReleaseDescription
              dangerouslySetInnerHTML={{
                __html: releaseNotes?.[idx]?.descriptionHtml ?? "",
              }}
            />
          </Typography>
        </DialogContent>
      ) : (
        <DialogContent>
          <DialogTitle>
            <Skeleton width={"100px"} />
          </DialogTitle>
          <DialogContentText marginBottom={3}>
            <Skeleton width={"400px"} />
          </DialogContentText>
        </DialogContent>
      )}
      <small>WebSuite Version: {packageJson.version}</small>
    </Dialog>
  );
};
